export default __webpack_public_path__ + "static/media/video-call.d707b6da.png";